import { render } from "./Mapeos.vue?vue&type=template&id=ebce0b70"
import script from "./Mapeos.vue?vue&type=script&lang=js"
export * from "./Mapeos.vue?vue&type=script&lang=js"

import exportComponent from "/Users/paulestrada/Desktop/PDESTRADA/Contablus/contablusDashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__